export default "\n<div class=\"root-container\">\n  <router-outlet></router-outlet>\n</div>"